import React, { useState, useEffect } from "react";
import { UseSupplier } from "./UseSupplier";
import {
  Autocomplete,
  TextField,
  Box,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import ProgressCom from "../../components/ProgressCom";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function SupplierSearchCom(props) {
  const { getSupplierByID, getSupplierListCombo } = UseSupplier();
  const [supplierRes, setSupplierRes] = React.useState();
  const location = useLocation();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [search, setSearch] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = React.useState();
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (props.selectedContractID) {
      getSupplierByID(props.selectedContractID, (advs) => {
        setSelectedOption(advs);
      });
    }
  }, [props.selectedContractID]);

  const handleSearch = () => {
    const query = searchText.trim();
    if (query.length > 0) {
      setProgress(true);
      getSupplierListCombo(query, (res) => {
        setOptions(res.items || []);
      });
    } else {
      setOptions([]);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: 2,
      }}
    >
      <Autocomplete
        options={options}
        value={selectedOption}
        onChange={(event, newValue) => {
          if (newValue) {
            setSelectedOption(newValue);
            props.onSelect?.(newValue?.id);
          } else {
            setSelectedOption();
            props.onSelect?.();
          }
        }}
        fullWidth
        getOptionLabel={(option) =>
          option?.companyName ? option.id + " - " + option.companyName : ""
        }
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label="جستجوی تامین کننده"
            error={props.errorState}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
                handleSearch();
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {searchText && (
                    <InputAdornment position="end">
                      <Button size="small" onClick={handleSearch}>
                        جستجو
                      </Button>
                    </InputAdornment>
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            placeholder=" تامین کننده را وارد کنید"
          />
        )}
      />
      <IconButton sx={{ p: 0 }} href="/suppliers" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
